
//export * from './http.js'
import * as Api from './api'
import * as Aoapi from './aoapi'
import * as Fsapi from './fsapi'

export default {
  Api,
  Aoapi,
  Fsapi
}



// WEBPACK FOOTER //
// ./src/api/index.js